import { DATE_FORMAT, formatShortISO, parse } from '@eneco/common/date';
import { RequestModels_Products_Offers_V3_OfferProductsPublicV3Request } from '@monorepo-types/dc';

import { FlowConsumerContextEnergy as FlowContext } from '../../../context';
import { getProductTypesFromEnergyType } from '../../helpers';

export const getOfferRequestBody = (
  values: FlowContext,
  allowDynamicOrHybridOnly: boolean,
): RequestModels_Products_Offers_V3_OfferProductsPublicV3Request => {
  return {
    data: {
      offerType: 'NewEnergyContract',
      address: {
        postalCode: values.postalCode?.replace(/\s/g, ''),
        houseNumber: values.houseNumber ?? 0,
        houseNumberSuffix: values.houseNumberSuffix,
      },
      usages: {
        electricityNormal: values.usageElectricityHigh,
        electricityLow: values.usageElectricityLow,
        electricityRedeliveryNormal: values.solarPanelsOutput ?? 0,
        electricityRedeliveryLow: 0,
        warmthElectricity: values.usageWarmth ?? 0,
        warmthWater: values.usageWater ?? 0,
        gas: values.usageGas ?? 0,
      },
      isMkb: !!values.isSME,
      isResidence: values.hasResidencePurpose ?? true,
      urgent: !!values.isUrgent,
      voucherCode: values.voucherCode,
      movingCustomer: !!values.isMoving,
      products: getProductTypesFromEnergyType(values.energyType),
      preferredContractStartDate: values.deliveryDate && formatShortISO(parse(values.deliveryDate, DATE_FORMAT)),
      // TODO: uncomment this line when we are ready to go live with a rental devices
      includeRentalProducts: !!values.isMoving,
      allowDynamicOrHybridOnly,
    },
  };
};

type OfferHashEvent = {
  type: 'GET_OFFER' | 'GET_EXTENSION_OFFER';
  flowContext: FlowContext;
  allowDynamicOrHybridOnly?: boolean;
};

/**
 * Builds a stable fingerprint of the inputs that determine an offer response. Two events with the
 * same fingerprint produce the same offer, so the cached response can be reused without refetching.
 * Contract-extension offers depend only on the account/customer, hence a distinct, prefixed shape.
 */
export const getOfferEventHash = ({ type, flowContext, allowDynamicOrHybridOnly = false }: OfferHashEvent): string => {
  if (type === 'GET_EXTENSION_OFFER') {
    return `extension:${flowContext.accountId}:${flowContext.customerId}`;
  }

  return `offer:${JSON.stringify(getOfferRequestBody(flowContext, allowDynamicOrHybridOnly))}`;
};
